import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faQuestion } from '@fortawesome/free-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { sanitizeHtml } from '../../utils/htmlSanitizer';
import { AppInfoButton } from './styles';

interface AppInfoProps {
    // eslint-disable-next-line react/require-default-props
    title?: string;
    // eslint-disable-next-line react/require-default-props
    message: string;
    // eslint-disable-next-line react/require-default-props
    icon?: 'info' | 'question';
    // eslint-disable-next-line react/require-default-props
    buttonStyle?: React.CSSProperties;
}

const AppInfo: React.FC<AppInfoProps> = (props) => {
    const { t } = useTranslation()

    const { message, title = t('Informacao'), icon = 'info', buttonStyle } = props;
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleOnClickAppInfoButton = () => {
        setIsOpen(true)
    }

    // Renderiza HTML de forma segura sem usar dangerouslySetInnerHTML
    const renderSafeMessage = (htmlMessage: string) => {
        if (!htmlMessage || typeof htmlMessage !== 'string') {
            return null;
        }

        // Sanitiza o HTML primeiro para remover qualquer conteúdo perigoso
        const sanitizedHtml = sanitizeHtml(htmlMessage);
        
        // Se não há tags HTML, retorna texto simples
        if (!sanitizedHtml.includes('<')) {
            return <span>{sanitizedHtml}</span>;
        }

        // Para conteúdo que contém HTML, utilizamos uma abordagem mais simples
        // Removemos tags não permitidas e criamos elementos React básicos
        
        // Converte quebras de linha em <br> e paragrafos
        const lines = sanitizedHtml.split(/<br\s*\/?>/i);
        const elements = lines.map((line, index) => {
            // Remove tags restantes e mantém apenas o texto
            const cleanLine = line.replace(/<[^>]*>/g, '').trim();
            
            if (cleanLine) {
                return (
                    <React.Fragment key={index}>
                        {cleanLine}
                        {index < lines.length - 1 && <br />}
                    </React.Fragment>
                );
            }
            return null;
        }).filter(Boolean);

        return <div>{elements}</div>;
    }

    return(
        <>
            <Modal
                modalClassName='tema-pergamum'
                isOpen={isOpen}
                toggle={() => setIsOpen(!isOpen)}
                size='lg'
                scrollable
            >
                <ModalHeader
                    style={{padding:"1rem 1rem 10px 1rem"}}
                    className="b-solid-bottom b-branco cortxt negrito"
                    toggle={() => setIsOpen(!isOpen)}
                    /* eslint-disable-next-line react/button-has-type */
                    close={<button
                        className="close s20 branco float-right mr-1 rad5"
                        style={{ fontWeight: 'normal' }}
                        onClick={() => setIsOpen(false)}
                    >
                        <FontAwesomeIcon icon="times" className="fa-fw" />
                    </button>}
                >
                    <div className="f700 branco s20 ">
                        {title}
                    </div>
                </ModalHeader>
                <ModalBody>
                    {renderSafeMessage(message)}
                </ModalBody>
                <ModalFooter className="d-flex justify-content-center align-items-center position-relative">
                    <Button
                        onClick={() => setIsOpen(false)}
                        className="danger" title={t('Ok')}>
                        {t('Ok')}
                    </Button>
                </ModalFooter>
            </Modal>
            <AppInfoButton onClick={handleOnClickAppInfoButton} style={buttonStyle}>
                <FontAwesomeIcon icon={(icon === 'question' ? faQuestion : faInfo) as IconProp} />
            </AppInfoButton>
        </>
    )
}

export default AppInfo;
